import React, {
    useState,
    useEffect,
    useLayoutEffect,
    useCallback,
    useContext,
    useRef,
} from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ContextMenu } from "primereact/contextmenu";
import { InputNumber } from "primereact/inputnumber";
import { TabView, TabPanel } from "primereact/tabview";

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputNumerico } from "../../../isp._comun/iu/componentes/widgets/InputNumerico";
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
import { InputTextarea } from "primereact/inputtextarea";

import GlobalContext     from "../../../isp._comun/iu/contexto/GlobalContext";

import Dialogo         from "../../../isp._comun/iu/_principal/componentes/layouts/Dialogo";
import EliminarVentana from "../../../isp._iu.start.principal/reductores/acciones/widgets/EliminarVentana";
import { ModosOp }     from "../../../isp._comun/iu/_principal/constantesIuPrin";

import * as Action from "../../reductores/acciones/dispatch/_ActionsDispatch";
import ActionServicioSet from "../../reductores/acciones/ActionServicioSet";
import SetTipoServicio from "../../reductores/acciones/dispatch/SetTipoServicio";

import { TiposDeItem, Moneda, Udm } from "../../../isp.žapi.servicios/constantesApiServicios";
import {TipoItemLabel, UnidadItemLabel, EstadosItemLabel } from "./žconstantesIuLayoutServicios";

// import { EstadosItemLabel } from "./žConstantes_Items";
import * as ModelosDeCombos from "./ModeloDeCombos_Servicios";
// import ComandoAPI from "../presentadores/ComandoAPI";

const DialogoServicioLayout = ({
    ventana,
    estadoDCF,
    dispatchDCF,
    registrarServicioCommand,
    actualizarServicioCommand,
    buscarUnSoloServicioCommand,
}) => {
    // const { dispatchPrincipal } = useContext(GlobalContext);
    const { eliminarVentana } = useContext(GlobalContext);

    // const isMounted = useRef(false);
    const inputnumeral = useRef(null);

    useEffect(() => {
        console.log("use effect se monto el componente padre ----");
        console.log(inputnumeral);
        // inputnumeral.current.maxLength=6;
    }, []);

    useEffect(() => {
        if (estadoDCF.flag.cargandoEntidad) {
            buscarUnSoloServicioCommand.ejecutar(estadoDCF.domain.screen.idItem);
        }
        return () => {buscarUnSoloServicioCommand.cancelar()};
    }, [estadoDCF.flag.cargandoEntidad]);

    useEffect(() => {
        if (!estadoDCF.flag.procesandoComando) {
            return;
        }

        // let comando = new ComandoAPI();
        if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) {
            // comando = registrarServicioCommand;
            registrarServicioCommand.ejecutar();
            return () => {
                registrarServicioCommand.cancelar();
            };
        }
        if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) {
            // comando = actualizarServicioCommand;
            actualizarServicioCommand.ejecutar();
            return () => {
                actualizarServicioCommand.cancelar();
            };
        }
        /* return () => {
            comando.cancelar();
        }; */
    }, [estadoDCF.flag.procesandoComando]);

    const cancelarClick = (eventoSynDom) => {
        eliminarVentana(ventana);
        // dispatchPrincipal(new EliminarVentana(ventana));
        eventoSynDom.stopPropagation();
    };

    const header = {
        elementoReact: <p className="p-2 bg-gradient-to-r from-purple-100">Servicio</p>,
        enProgreso: estadoDCF.flag.procesandoComando,
    };

    /* let bloqueTipoDeItem = null;

    if(estadoDCF.flag.modoOperacion === ModosOp.CREAR){
        bloqueTipoDeItem = 
            <Dropdown
                value={estadoDCF.domain.screen.tipoItem}
                options={ModelosDeCombos.tiposItem}                          
                onChange={(e) => {
                    dispatchDCF(new SetTipoServicio("tipoItem", e.value));
                }}
                className="p-0 w-full rounded-none"
                // panelClassName="p-0"
                // panelStyle={{ padding: 0 }}
                disabled={estadoDCF.flag.procesandoComando}
            />
    }else{
        const labelTipoItem = ModelosDeCombos.tiposItem.find((tipoItem)=>{
            if(tipoItem.value === estadoDCF.domain.screen.tipoItem)return true;
        });
        bloqueTipoDeItem = labelTipoItem.label;
    } */

    let bloqueCampos01 = (
        <div className="flex justify-between flex-wrap">
            <div>
                <div className="flex">
                    <div className="flex">
                        <div className="w-40">Id. de Servicio : </div>
                        <div>{estadoDCF.domain.screen.idItem}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div className="flex mt-1">
                    <div className="w-40 shrink-0">Minicodigo : </div>
                    <InputText
                        id="in"
                        value={estadoDCF.domain.screen.nombre}
                        className="p-0 w-32 rounded-none"
                        onChange={(e) =>
                            dispatchDCF(
                                new ActionServicioSet("nombre", e.target.value)
                                // new Action.SetNombres(e.target.value)
                            )
                        }
                        maxLength={10}
                        disabled={estadoDCF.flag.procesandoComando}
                    />
                    <div className="flex">
                        <div className="w-40"></div>
                    </div>       
                </div>
            </div>    
            <div>
                <div className="flex">
                    <div className="w-40 shrink-0">Fecha de Registro : </div>
                    <div>{estadoDCF.domain.screen.fechaReg}</div>
                </div>
                <div className="flex mt-1">
                    <div className="w-40">Estado Deudor : </div>
                    <div>{EstadosItemLabel[estadoDCF.domain.screen.estado]}</div>
                </div>
                <div className="flex mt-1">
                    <div className="w-40">Estado / Actividad : </div>
                    <div>{EstadosItemLabel[estadoDCF.domain.screen.estado]}</div>
                </div>
            </div>
        </div>
    );

    let bloqueCampos02 = (
        <div className="flex justify-between flex-wrap">
            <div className="mr-10">
                <div className="flex">
                    <div className="flex">
                        <div className="w-32">Id. del Cliente : </div>                        
                        <Button
                        // label="Cancelar"
                        icon="pi pi-caret-right"
                        onClick={(eventoDom) => cancelarClick(eventoDom)}
                        // disabled={estadoDCF.flag.procesandoComando}
                        className="p-button-rounded p-button-text p-button-warning w-6 h-6 ml-1"
                        // className="w-32"
                        />
                        <div className="ml-1">{estadoDCF.domain.screen.idItem}</div>
                    </div>
                    <Button
                        // label="Cancelar"
                        icon="pi pi-bars"
                        onClick={(eventoDom) => cancelarClick(eventoDom)}
                        // disabled={estadoDCF.flag.procesandoComando}
                        className="p-button-rounded p-button-outlined p-button-warning w-7 h-6 ml-4"
                        // className="w-32"
                    />
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div className="flex mt-1">
                    <div className="flex">
                        <div className="w-40">N° de Cliente : </div>
                        <div>{estadoDCF.domain.screen.idItem}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div className="flex mt-1">
                    <div className="flex">
                        <div className="w-40">Nombre / Cliente : </div>
                        <div>{estadoDCF.domain.screen.idItem}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>

                <hr className="my-5"></hr>

                <div className="flex">
                    <div className="flex">
                        <div className="w-40">Id del Plan : </div>
                        <div>{estadoDCF.domain.screen.idItem}</div>
                    </div>
                    <Button
                        // label="Cancelar"
                        icon="pi pi-bars"
                        onClick={(eventoDom) => cancelarClick(eventoDom)}
                        // disabled={estadoDCF.flag.procesandoComando}
                        className="p-button-rounded p-button-outlined p-button-warning w-7 h-6 ml-4"
                        // className="w-32"
                    />
                    <Button
                        // label="Cancelar"
                        icon="pi pi-clone"
                        onClick={(eventoDom) => cancelarClick(eventoDom)}
                        // disabled={estadoDCF.flag.procesandoComando}
                        className="p-button-rounded p-button-outlined p-button-warning w-7 h-7 ml-2"
                        // className="w-32"
                    />
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div className="flex mt-1">
                    <div className="flex">
                        <div className="w-40">Nombre del Plan : </div>
                        <div>{estadoDCF.domain.screen.idItem}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                
                <hr className="my-5"></hr>

                <div className="flex mb-2">
                    <div className="flex">
                        <div className="w-32">Id. / Zona : </div>                        
                        <Button
                        // label="Cancelar"
                        icon="pi pi-caret-right"
                        onClick={(eventoDom) => cancelarClick(eventoDom)}
                        // disabled={estadoDCF.flag.procesandoComando}
                        className="p-button-rounded p-button-text p-button-warning w-6 h-6 ml-1"
                        // className="w-32"
                        />
                        <div className="ml-1">{estadoDCF.domain.screen.idItem}</div>
                    </div>
                    <Button
                        // label="Cancelar"
                        icon="pi pi-bars"
                        onClick={(eventoDom) => cancelarClick(eventoDom)}
                        // disabled={estadoDCF.flag.procesandoComando}
                        className="p-button-rounded p-button-outlined p-button-warning w-7 h-6 ml-4"
                        // className="w-32"
                    />
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div className="flex mt-2">
                    <div className="w-40 shrink-0">Zona : </div>
                    <div>{estadoDCF.domain.screen.idItem}</div>
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div className="flex mt-2">
                    <div className="w-32 shrink-0">Direccion : </div>
                    <div className="pl-0">
                        <InputTextarea
                            id="in"
                            value={estadoDCF.domain.screen.descripcion}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionServicioSet("descripcion", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            rows={3}
                            cols={31}
                            maxLength={200}
                            autoResize={false}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                    </div>
                </div>
            </div>
            <div>
                
                
                <div className="flex">
                    <div className="w-40">Tipo / Comprobante : </div>
                    <div>
                        <Dropdown
                            value={estadoDCF.domain.screen.moneda}
                            options={ModelosDeCombos.tiposComprobantesCombo}
                            onChange={(e) => {
                                dispatchDCF(new ActionServicioSet("moneda", e.target.value));
                                // dispatchDCF(new Action.SetTipoDoc(e.value));
                            }}
                            placeholder="Seleccionar..."
                            // placeholder="Selecciona un Tipo"
                            className="p-0 w-full rounded-none"
                            // panelClassName="p-0"
                            // panelStyle={{ padding: 0 }}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                    </div>
                </div>

                <div className="flex mt-3">
                    <div className="w-40 shrink-0">Ciclo / Fact. : </div>
                    <div className="pl-0">
                        <Dropdown
                            value={estadoDCF.domain.screen.udm}
                            /* options={ModelosDeCombos.ciclosFactCombo.filter((cicloCombo) => {
                                return estadoDCF.domain.screen.combos.udms.includes(
                                    cicloCombo.value
                                );
                            })} */
                            options={ModelosDeCombos.ciclosFactCombo}
                            onChange={
                                (e) => dispatchDCF(new ActionServicioSet("udm", e.target.value))
                                // dispatchDCF(new Action.SetSexo(e.value))
                            }
                            placeholder="Seleccionar..."
                            className="p-0 w-full rounded-none"
                            // panelClassName="p-0"
                            // panelStyle={{ padding: 0 }}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.sexoBlanc ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            Se requiere elegir un Género.
                        </small>
                    </div>
                </div>
                
                <div className="flex mt-3">
                    <div className="w-40 shrink-0">Pto. PON : </div>
                    <div className="pl-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.nombre}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionServicioSet("nombre", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            maxLength={40}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={estadoDCF.error.nomBlanc ? "mb-1.5 block p-error" : "hidden"}
                        >
                            Se requiere Nombres del Item.
                        </small>
                        <small
                            id=""
                            className={estadoDCF.error.nomMF ? "mb-1.5 block p-error" : "hidden"}
                        >
                            El formato del Nombre es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mt-3">
                    <div className="w-40 shrink-0">Caja Distrib. : </div>
                    <div className="pl-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.nombre}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionServicioSet("nombre", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            maxLength={40}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={estadoDCF.error.nomBlanc ? "mb-1.5 block p-error" : "hidden"}
                        >
                            Se requiere Nombres del Item.
                        </small>
                        <small
                            id=""
                            className={estadoDCF.error.nomMF ? "mb-1.5 block p-error" : "hidden"}
                        >
                            El formato del Nombre es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mt-3">
                    <div className="w-40 shrink-0">N° Serie ONT : </div>
                    <div className="pl-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.nombre}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionServicioSet("nombre", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            maxLength={40}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={estadoDCF.error.nomBlanc ? "mb-1.5 block p-error" : "hidden"}
                        >
                            Se requiere Nombres del Item.
                        </small>
                        <small
                            id=""
                            className={estadoDCF.error.nomMF ? "mb-1.5 block p-error" : "hidden"}
                        >
                            El formato del Nombre es incorrecto.
                        </small>
                    </div>
                </div>
            </div>
        </div>
    );

    let bloqueAtributos = null;

    if (estadoDCF.flag.cargandoEntidad) {
        bloqueAtributos = (
            <>
                <div className="flex flex-row justify-between">
                    <Skeleton width="45%" height="6rem"></Skeleton>
                    <Skeleton width="40%" height="6rem"></Skeleton>
                </div>
                <br></br>
                <br></br>
                <div>
                    <Skeleton width="100%" height="10rem"></Skeleton>
                </div>
            </>
        );
    } else {
        bloqueAtributos = (
            <>
                {bloqueCampos01}
                {/* <div className="flex justify-between flex-wrap">{bloqueCampos01}</div> */}
                <hr className="my-3"></hr>
                {bloqueCampos02}
                {/* <div className="flex justify-between flex-wrap">{bloqueCampos02}</div> */}
            </>
        );
    }

    const labelBotonAccion = (() => {
        if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) return "Guardar";
        if (estadoDCF.flag.modoOperacion === ModosOp.OK) return "   OK    ";
        if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) return "Modificar";
    })();

    const footer = (
        <div>
            <Button
                label={labelBotonAccion}
                icon="pi pi-check"
                onClick={(eventoSynDom) => {
                    if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) {
                        dispatchDCF(new Action.GuardarServicio());
                        // registrarClienteAFacturar();
                        return;
                    }
                    if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) {
                        dispatchDCF(new Action.ActualizarServicio());
                        // actualizarClienteAFacturar();
                        return;
                    }
                    if (estadoDCF.flag.modoOperacion === ModosOp.OK) {
                        cancelarClick(eventoSynDom);
                        return;
                    }
                }}
                loading={estadoDCF.flag.procesandoComando}
                iconPos="left"
                className="whitespace-pre"
            />
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={(eventoDom) => cancelarClick(eventoDom)}
                disabled={estadoDCF.flag.procesandoComando}
                // className="w-32"
            />
        </div>
    );

    

    return (
        <Dialogo
            ventana={ventana}
            cabecera={header}
            modal={estadoDCF.flag.modal}
            posicionZ={ventana.posicionZ}
            pie={footer}
            estilo={{ width: "56rem", minHeight: "35vh", top: "15vh", margin: "0" }}
        >
            {bloqueAtributos}
        </Dialogo>
    );
};

export default DialogoServicioLayout;
